import { combineReducers } from "redux";
import { spitems } from "src/modules/spItems/reducers";
import { vpo } from "src/modules/vpo/reducers";
import { rootVpo } from "src/pages/DashboardPage/vpo/reducers/root-reducer";
import { gos } from "src/modules/gos/reducers";
import { users } from "src/modules/users/reducer";
import { searchUsers } from "../components/ui/form/peoplePicker/reducers";
import { rootGop } from "src/pages/DashboardPage/gop/reducers/root-reducer";
import { checklistTasks } from "src/modules/checklistTasks/reducer";
import { rootGos } from "src/pages/DashboardPage/gos/reducers/root-reducer";
import { changeApprovers } from "src/modules/changeApprovers/reducer";
import { rootMyTasks } from "src/pages/DashboardPage/mytasks/reducers/root-reducer";

const rootReducer = combineReducers({
  spitems: spitems,
  users: users,
  searchUsers,
  vpo,
  vpoStrapi: rootVpo,
  gos,
  gop: rootGop,
  checklistTasks,
  gosStrapi: rootGos,
  changeApprovers,
  myTasksStrapi: rootMyTasks,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
